/***
**Module Name: Company details
 **File Name :  Company.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains compant tables details.
 ***/

import React, { useState, useEffect, useContext } from "react";


import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
import Sidebar from "../../../components/dashboard/sidebar";
import tmdbApi from "../../../api/tmdbApi";
import { useHistory, Link, useLocation } from "react-router-dom";
import TableLoader from "../../../components/tableLoader";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../../context/contentContext";
import SessionPopup from "../../SessionPopup"
import DataTable from 'react-data-table-component';
import Loader from "../../../components/loader";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

let { lambda, appname } = window.app;



const Company = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { search } = state || {};

    const [success, setSuccess] = useState(false);


    const [searchvalue, setSearch] = useState("");
    const [answersdata, setAnswers] = useState([]);
    const [formData, setFormData] = useState({
        answer: ""
    });
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);

    const [popup, setShowPopup] = useState(false);
    const [typeSelected, setType] = useState(false);
    const [answerId, setAnswerId] = useState(null);
    const [contentLoaded, setcontentLoaded] = useState(false);

    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [deleteAnswer, setdeleteAnswer] = useState(false);
    const [deleteAnswerId, setDeleteAnswerId] = useState(null);

    // const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)

    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu == "Client Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[1] && validateObj[0].submenus[1].dashboard


    const getSerialNumber = (index) => {
        // Serial number calculation: it continues from the last serial number of the previous page
        return (currentPageNew - 1) * rowsPerPage + index + 1;
    };



    const columns = [

        {
            name: 'Sl No',
            selector: (row, index) => {
                return getSerialNumber(index);
            },
        },
        {
            name: 'Answers',
            selector: row => row?.answer ?? "",
            sortable: true,
        },
 
        {
            name: 'Created Date',
            selector: row => row?.created ? moment.utc(row?.created).format('DD MMM YYYY, h:mm A') : "",
            // cell: (props) => props?.created ? new Date(props?.created).toLocaleDateString('en-IN', {
            //     day: 'numeric',
            //     month: 'short',
            //     year: 'numeric',
            //     hour: 'numeric',
            //     minute: 'numeric',
            // }) : "",
            sortable: true,
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        {
            name: 'Actions',
            cell: (props) =>
                //  {subValDashboard && subValDashboard.view && subValDashboard.edit && (subValDashboard.view.display === true || subValDashboard.edit.display === true) &&
                <div className="d-flex">

                    <a className='text-info action-button' onClick={(e) => handleEditPopup(e, 'Edit', props)}><i className="mdi mdi-pencil font-size-18"></i></a>
                    <a className='text-danger action-button' onClick={(e) => handleDelete(e, props)}><i className="mdi mdi-delete font-size-18"></i></a>
                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];



    const keyForRerender = `${rowsPerPage}_${data?.length}`;

    const handlePageChange = (page) => {
        setCurrentPage(page);
        // console.log("pageeeeeeeeeeeeeeeeeeeeeee",page)
    };

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };


    const handleShowPopup = (e, type) => {
        e.preventDefault()
        setType(type)
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": "", // Update the changed field
        }));
        setShowPopup(false);
        setAnswerId(null)
    }

    const handleEditPopup = (e, type, props) => {
        e.preventDefault()
        setType(type)
        setShowPopup(true);
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": props.answer, // Update the changed field
        }));
        setAnswerId(props.answerid)

    };


    useEffect(() => {

        if (!localStorage.getItem("token")) {
            history.push("/");
        }

        setCurrentPage(1)
        GetAnswersInfo()
    }, []);
    // console.log('dataaaaaaaa',data)
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "COMPANY NAME": Array.isArray(each?.companyname) ? each?.companyname?.[0] : each?.companyname ?? "",
            "EMAIL ID": each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "COMPANY TYPE": each?.companytype ?? "",
            "ENTITY": each?.entity ?? "",
            "CONTENT TYPE": each?.contenttype ?? "",
            "ACCOUNT MANAGER": each?.accountmanager ?? "",

            "CREATED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",
            // "STATUS": status,
        }));
        // console.log('data2 after',data2)

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data, `CompaniesData.xlsx`);
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };


    const handleSearch = async (e) => {
        setIsLoading(true)
        try {

            const response = await tmdbApi.answerSearchInfo(searchvalue);
            setAnswers(response?.result);
            setIsLoading(false);
            setCurrentPage(1)

        } catch {
            console.log("error");
        }
    }
    const pageSearch = async (page) => {
        setIsLoading(true)
        try {

            const response = await tmdbApi.answerSearchInfo(searchvalue);
            setAnswers(response?.result);
            setIsLoading(false);
            setCurrentPage(page)

        } catch {
            console.log("error");
        }
    }
    function onConfirm() {
        setSuccess(false);
        setShowPopup(false);
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            "answer": "", // Update the changed field
        }))
        
        // setSearch(null)
        console.log('sss', currentPageNew)
        if(searchvalue){
            pageSearch(currentPageNew)
            setCurrentPage(currentPageNew)
        }else {
            GetAnswersInfo()
            setCurrentPage(currentPageNew)
        }
        
        
    };

    const GetAnswersInfo = async () => {

        setIsLoading(true)
        try {
            const response = await tmdbApi.answerInfo();
            setAnswers(response?.result);
            setIsLoading(false)
            setcontentLoaded(true)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };


    const handleSubmit = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createAnswer(formData);
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (formData?.answer == "") {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "Please enter Answer", // Update the changed field
            }));
            seterrorDisplay(true)
            setTimeout(function () { seterrorDisplay(false) }, 3000);
            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["answer"]: "", // Update the changed field
            }));
        }

        return formIsValid;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: value, // Update the changed field
        }));
    };

    const onDelete = async (e) => {
        try {
            const response = await tmdbApi.deleteAnswer(deleteAnswerId);
            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
        setDeleteSuccess(true)
        setdeleteAnswer(false)

    }

    const ondeleteConfirm = (e) => {
        setDeleteSuccess(false)
        GetAnswersInfo()
        setDeleteAnswerId(null)
        setSearch(null)
    }


    const onCancel = (e) => {
        setdeleteAnswer(false)

    }

    const handleDelete = async (e, props) => {

        setdeleteAnswer(true)
        setDeleteAnswerId(props.answerid)
    }

    const handleSearchChange = (e) => {
        setSearch(e.target.value)
    }

    const clearSearch = () => {
        setSearch(null);
        GetAnswersInfo()
    }

    const createAnswer = async (formData) => {
        try {
            let response;
            if (typeSelected == "Add") {
                response = await tmdbApi.AddAnswer(formData);
            } else {
                response = await tmdbApi.UpdateAnswer(formData, answerId);
            }

            console.log(response);
            // if (response?.statusCode == 200) {
            setSuccess(true);
            //  }
        } catch {
            console.log("error");
        }
    };

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }

    console.log("currentPageNew", currentPageNew);
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                {isLoading ? <Loader /> : <div className="quiz-page main-content user-management clients company answers-page-section">

                    <div className="page-content">
                        <div className="container-fluid">




                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Answers</h4>

                                        </div>

                                        <div>
                                            <button onClick={(e) => handleShowPopup(e, 'Add')} className="btn btn-primary" >ADD</button>
                                        </div>


                                    </div>
                                </div>
                            </div>



                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mb-2">
                                                {/* <div className="col-sm-4 button-block"> */}
                                                {/* <div className="dataTables_length" id="datatable_length">
                                                     <button className={`fill_btn ${data.length <= 0 ?'disable pe-none':''}`} onClick={handleExport}><span className="material-icons">north_east</span>Export</button>
                                                 </div> */}
                                                {/* </div> */}
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block">

                                                        <div className="position-relative">
                                                            <input type="text" className="form-control" value={searchvalue ? searchvalue : ""} onChange={(e) => handleSearchChange(e)} placeholder="Search " />
                                                            <button className="fill_btn" onClick={(e) => handleSearch(e)}><span className="material-icons search-icon">search</span></button>
                                                        </div>

                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button className="fill_btn" onClick={(e) => clearSearch(e)}><span className="material-icons-outlined">sync</span>Reset</button>
                                                        </div>

                                                    </div>
                                                    <div className="text-sm-end">

                                                    </div>
                                                </div>
                                            </div>


                                            < DataTable key={keyForRerender}
                                                // title=""
                                                columns={columns}
                                                // className="table align-middle table-nowrap table-check"
                                                keyField='_id'
                                                data={answersdata}
                                                direction="auto"
                                                highlightOnHover

                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                noDataComponent={customNoRecords()}
                                                persistTableHead
                                                // selectableRowsVisibleOnly
                                                striped
                                                // selectableRowsHighlight
                                                // selectableRows
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                subHeaderWra
                                                // noDataComponent={customNoRecords()}
                                                paginationTotalRows={answersdata.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}

                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                            // progressPending={isLoading}
                                            // progressComponent={<TableLoader />}

                                            />




                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={typeSelected == "Add" ? "Answer Added Successfully" : "Answer Updated Successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteAnswer}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure to delete the Answer?"
                        focusCancelBtn
                        onConfirm={e => onDelete()}
                        onCancel={e => onCancel()}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => ondeleteConfirm()}
                    >
                    </SweetAlert>

                    <Modal className="advance-search search-popup" show={popup} onHide={handleClosePopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>{typeSelected == "Add" ? `Add` : `Update`} Answer</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="input-field">
                                            <label className="col-form-label">Answer</label>
                                            <input className="form-control" placeholder="Enter Answer" type="text" name="answer" onChange={(e) => handleChange(e)}
                                                value={formData?.answer} />
                                            {errorDisplay && <span className="errormsg" style={{
                                                fontWeight: 'bold',
                                                color: 'red',
                                            }}>{errorData?.answer}</span>}
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="adv_footer">

                                <button onClick={(e) => handleSubmit(e)}>
                                    SUBMIT
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <Footer />
                </div>
                }

            </div>
        </>
    );
};

export default Company;
